const Menu = [
  { 
  	path: '/', icon: 'fa fa-th', title: 'Inicio'
  }, 
  {
    path: '/solicitudesEstablecimientos', icon: 'fa fa-address-card', title: 'Solicitudes'
  } 
]

export default Menu;
